"use client"

import type React from "react"

interface LocationFormProps {
  latitude: string
  longitude: string
  onLatitudeChange: (latitude: string) => void
  onLongitudeChange: (longitude: string) => void
}

const LocationForm: React.FC<LocationFormProps> = ({ latitude, longitude, onLatitudeChange, onLongitudeChange }) => {
  return (
    <div className="form-group">
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="location-latitude">Latitude:</label>
          <input
            id="location-latitude"
            type="text"
            value={latitude}
            onChange={(e) => onLatitudeChange(e.target.value)}
            placeholder="e.g. 37.7749"
            className="text-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="location-longitude">Longitude:</label>
          <input
            id="location-longitude"
            type="text"
            value={longitude}
            onChange={(e) => onLongitudeChange(e.target.value)}
            placeholder="e.g. -122.4194"
            className="text-input"
          />
        </div>
      </div>
      <div className="location-help">
        <p>Tip: You can find coordinates by right-clicking on Google Maps and selecting "What's here?"</p>
      </div>
    </div>
  )
}

export default LocationForm
